import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -40%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const InstallPromptContainer = styled.div`
  display: contents;

  /* ==========================================================================
     OVERLAY
     ========================================================================== */
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3) !important;
    backdrop-filter: blur(2px);
    z-index: 10000;
    animation: ${fadeIn} 0.2s ease-out;
    height: 100vh !important;
    width: 100vw !important;
  }

  /* ==========================================================================
     MODAL
     ========================================================================== */
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${(p) => p.theme.colors.surface} !important;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    z-index: 10001;
    width: 90%;
    max-width: 360px;
    height: auto !important;
    animation: ${slideUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 24px;
    text-align: center;
  }

  /* ==========================================================================
     ICON CONTAINER
     ========================================================================== */
  .icon-container {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: ${(p) => p.theme.colors.primary};
    color: ${(p) => p.theme.colors.onPrimary};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    svg {
      stroke-width: 2.5px;
    }
  }

  /* ==========================================================================
     TITLE
     ========================================================================== */
  .title {
    font-size: 1.25rem;
    font-weight: 700;
    color: ${(p) => p.theme.colors.text};
    margin: 0 0 10px 0;
    letter-spacing: -0.02em;
  }

  /* ==========================================================================
     DESCRIPTION
     ========================================================================== */
  .description {
    font-size: 0.9rem;
    color: ${(p) => p.theme.colors.textLight};
    margin: 0 0 28px 0;
    line-height: 1.5;
  }

  /* ==========================================================================
     BUTTON GROUP
     ========================================================================== */
  .button-group {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 100%;
  }

  /* ==========================================================================
     BUTTONS
     ========================================================================== */
  .button {
    width: 100%;
    padding: 14px;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: transparent;
    color: ${(p) => p.theme.colors.textLight};
    border: 1px solid ${(p) => p.theme.colors.textLight}40;

    &:hover {
      background: ${(p) => p.theme.colors.backgroundLight}40;
      color: ${(p) => p.theme.colors.text};
      border-color: ${(p) => p.theme.colors.textLight};
    }
  }

  .button-primary {
    background: ${(p) => p.theme.colors.primaryDark};
    color: white;
    box-shadow: 0 4px 12px ${(p) => p.theme.colors.primaryDark};
    border: none;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 16px ${(p) => p.theme.colors.primaryDark};
      background: ${(p) => p.theme.colors.primaryDark};
      color: white;
    }

    &:active {
      transform: translateY(0);
    }
  }

  /* ==========================================================================
     CHECKBOX
     ========================================================================== */
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 20px;
    cursor: pointer;
    user-select: none;
    opacity: 0.8;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }

  .checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: ${(p) => p.theme.colors.primary};
    border-radius: 4px;
  }

  .checkbox-label {
    font-size: 0.85rem;
    color: ${(p) => p.theme.colors.textLight};
  }
`;

export default InstallPromptContainer;
